// SPA 設定。infra（Cognito UserPool / SPA Client / HTTP API）の出力をビルド時に VITE_* で注入する。
// 必須値が欠落/空のときは throw（フェイルクローズ。空設定での本番ビルドを防ぐ）。

export interface AppConfig {
  readonly region: string;
  readonly userPoolId: string;
  readonly spaClientId: string;
  readonly apiBaseUrl: string;
}

const REQUIRED_KEYS = [
  "VITE_AWS_REGION",
  "VITE_USER_POOL_ID",
  "VITE_SPA_CLIENT_ID",
  "VITE_API_BASE_URL",
] as const;

export function loadConfig(env: Record<string, string | undefined>): AppConfig {
  for (const key of REQUIRED_KEYS) {
    const value = env[key];
    if (value === undefined || value.trim() === "") {
      throw new Error(`Missing required environment variable: ${key}`);
    }
  }
  return {
    region: env["VITE_AWS_REGION"] as string,
    userPoolId: env["VITE_USER_POOL_ID"] as string,
    spaClientId: env["VITE_SPA_CLIENT_ID"] as string,
    apiBaseUrl: env["VITE_API_BASE_URL"] as string,
  };
}

// 実行時はビルド埋め込みの import.meta.env を使用。
export const config: AppConfig = loadConfig(
  import.meta.env as unknown as Record<string, string | undefined>,
);
